"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyQueryUploadDetail = exports.StudyQueryUpload = exports.StudyCaptureItemSummary = exports.StudyQuery = exports.StudyQueryUploadDetailStatus = exports.StudyQueryUploadDetailValidateStatus = exports.StudyQueryUploadDetailApplyStatus = exports.StudyQueryUploadValidateStatus = exports.StudyQueryUploadApplyStatus = exports.StudyQueryUploadPrepareStatus = exports.StudyQueryStatus = exports.StudyQueryType = void 0;
var StudyQueryType;
(function (StudyQueryType) {
    StudyQueryType["Auto"] = "AUTO";
    StudyQueryType["Manual"] = "MANUAL";
})(StudyQueryType = exports.StudyQueryType || (exports.StudyQueryType = {}));
var StudyQueryStatus;
(function (StudyQueryStatus) {
    StudyQueryStatus["Pending"] = "PENDING";
    StudyQueryStatus["Open"] = "OPEN";
    StudyQueryStatus["Resolving"] = "RESOLVING";
    StudyQueryStatus["Resolved"] = "RESOLVED";
    StudyQueryStatus["ForceResolved"] = "FORCE_RESOLVED";
    StudyQueryStatus["Cancelled"] = "CANCELLED";
    StudyQueryStatus["ForceCancelled"] = "FORCE_CANCELLED";
    StudyQueryStatus["Claimed"] = "CLAIMED";
    StudyQueryStatus["ForceClaimed"] = "FORCE_CLAIMED";
    StudyQueryStatus["AutoClosed"] = "AUTO_CLOSED";
})(StudyQueryStatus = exports.StudyQueryStatus || (exports.StudyQueryStatus = {}));
var StudyQueryUploadPrepareStatus;
(function (StudyQueryUploadPrepareStatus) {
    StudyQueryUploadPrepareStatus["Wait"] = "WAIT";
    StudyQueryUploadPrepareStatus["Processing"] = "PROCESSING";
    StudyQueryUploadPrepareStatus["Done"] = "DONE";
    StudyQueryUploadPrepareStatus["Failed"] = "FAILED";
})(StudyQueryUploadPrepareStatus = exports.StudyQueryUploadPrepareStatus || (exports.StudyQueryUploadPrepareStatus = {}));
var StudyQueryUploadApplyStatus;
(function (StudyQueryUploadApplyStatus) {
    StudyQueryUploadApplyStatus["None"] = "NONE";
    StudyQueryUploadApplyStatus["Wait"] = "WAIT";
    StudyQueryUploadApplyStatus["Processing"] = "PROCESSING";
    StudyQueryUploadApplyStatus["Succeed"] = "SUCCEED";
    StudyQueryUploadApplyStatus["PartiallySucceed"] = "PARTIALLY_SUCCEED";
    StudyQueryUploadApplyStatus["Failed"] = "FAILED";
})(StudyQueryUploadApplyStatus = exports.StudyQueryUploadApplyStatus || (exports.StudyQueryUploadApplyStatus = {}));
var StudyQueryUploadValidateStatus;
(function (StudyQueryUploadValidateStatus) {
    StudyQueryUploadValidateStatus["Wait"] = "WAIT";
    StudyQueryUploadValidateStatus["Processing"] = "PROCESSING";
    StudyQueryUploadValidateStatus["Succeed"] = "SUCCEED";
    StudyQueryUploadValidateStatus["PartiallySucceed"] = "PARTIALLY_SUCCEED";
    StudyQueryUploadValidateStatus["Failed"] = "FAILED";
})(StudyQueryUploadValidateStatus = exports.StudyQueryUploadValidateStatus || (exports.StudyQueryUploadValidateStatus = {}));
var StudyQueryUploadDetailApplyStatus;
(function (StudyQueryUploadDetailApplyStatus) {
    StudyQueryUploadDetailApplyStatus["None"] = "NONE";
    StudyQueryUploadDetailApplyStatus["Wait"] = "WAIT";
    StudyQueryUploadDetailApplyStatus["Processing"] = "PROCESSING";
    StudyQueryUploadDetailApplyStatus["Succeed"] = "SUCCEED";
    StudyQueryUploadDetailApplyStatus["Failed"] = "FAILED";
})(StudyQueryUploadDetailApplyStatus = exports.StudyQueryUploadDetailApplyStatus || (exports.StudyQueryUploadDetailApplyStatus = {}));
var StudyQueryUploadDetailValidateStatus;
(function (StudyQueryUploadDetailValidateStatus) {
    StudyQueryUploadDetailValidateStatus["Wait"] = "WAIT";
    StudyQueryUploadDetailValidateStatus["Processing"] = "PROCESSING";
    StudyQueryUploadDetailValidateStatus["Succeed"] = "SUCCEED";
    StudyQueryUploadDetailValidateStatus["Failed"] = "FAILED";
})(StudyQueryUploadDetailValidateStatus = exports.StudyQueryUploadDetailValidateStatus || (exports.StudyQueryUploadDetailValidateStatus = {}));
var StudyQueryUploadDetailStatus;
(function (StudyQueryUploadDetailStatus) {
    StudyQueryUploadDetailStatus["Open"] = "OPEN";
    StudyQueryUploadDetailStatus["InvalidData"] = "INVALID_DATA";
})(StudyQueryUploadDetailStatus = exports.StudyQueryUploadDetailStatus || (exports.StudyQueryUploadDetailStatus = {}));
class StudyQuery {
}
exports.StudyQuery = StudyQuery;
class StudyCaptureItemSummary {
}
exports.StudyCaptureItemSummary = StudyCaptureItemSummary;
class StudyQueryUpload {
}
exports.StudyQueryUpload = StudyQueryUpload;
class StudyQueryUploadDetail {
}
exports.StudyQueryUploadDetail = StudyQueryUploadDetail;
//# sourceMappingURL=studyQuery.js.map